// src/Pages/CancelPage.js
import React from "react";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import "@fontsource/chivo";

const CancelPage = () => {
  return (
    <div className="bg-white text-black min-h-screen flex flex-col">
      <NavbarWhite />

      <div className="pt-32 px-4 sm:px-6 text-center flex-1">
        <h1 className="text-4xl sm:text-5xl font-[chivo] text-red-600 mb-6">
          Pagamento Annullato ❌
        </h1>
        <p className="text-lg font-[chivo] text-gray-700 max-w-xl mx-auto">
          Il pagamento è stato annullato. Puoi riprovare oppure tornare al menù per modificare l'ordine.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default CancelPage;
